// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"3e5aed1d","898":"8d6990c0"}[chunkId] + ".chunk.css";
};